import { IconButton, Tooltip } from '@mui/material';
import { ErrorType } from '.';
import TonalIconButton from '@/components/TonalIconButton';
import { Refresh as RetryIcon, Close as CloseIcon } from '@mui/icons-material';
import Space from '@/components/Space';
import TonalButton from '@/components/TonalButton';
import { FormattedMessage } from 'react-intl';
import FormattedHtmlMessage from '@/components/FormattedHtmlMessage';

type UploadErrorStateProps = {
  error: ErrorType;
  onRetry: () => void;
  canRetry: boolean;
  onDismiss: () => void;
};

const UploadErrorState = ({
  error,
  onRetry,
  canRetry,
  onDismiss,
}: UploadErrorStateProps) => {
  if (error === ErrorType.FILE_TOO_LARGE) {
    return (
      <>
        <span>
          <FormattedHtmlMessage id="portfolio.challenge.files.add.upload_file.errors.file_too_large.label" />
        </span>
        <Tooltip
          title={
            <FormattedMessage id="portfolio.challenge.files.add.upload_file.errors.file_too_large.upload_different_file_tooltip" />
          }
        >
          <TonalIconButton size="small" onClick={onDismiss}>
            <RetryIcon fontSize="small" />
          </TonalIconButton>
        </Tooltip>
      </>
    );
  }

  return (
    <>
      <span>
        <FormattedMessage id="portfolio.challenge.files.add.upload_file.errors.generic.label" />
      </span>
      {canRetry && (
        <>
          <TonalButton size="small" startIcon={<RetryIcon />} onClick={onRetry}>
            <FormattedMessage id="portfolio.challenge.files.add.upload_file.errors.generic.retry_button" />
          </TonalButton>
          <Space width={6} />
        </>
      )}
      <Tooltip
        title={
          <FormattedMessage id="portfolio.challenge.files.add.upload_file.errors.generic.dismiss_tooltip" />
        }
      >
        <IconButton size="small" onClick={onDismiss}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default UploadErrorState;
